import { useEffect, useState } from "react";
import { verifySession } from "../lib/auth.js";

export type AuthStatus = "checking" | "authenticated" | "unauthenticated";

export function useAuth(): AuthStatus {
  const [status, setStatus] = useState<AuthStatus>("checking");

  useEffect(() => {
    verifySession().then((valid) => {
      setStatus(valid ? "authenticated" : "unauthenticated");
    });
  }, []);

  return status;
}
